import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import hasClaimForCompany from '../../../../lib/hasClaimForCompany'
import Claims from '../../../../lib/claims'
import { CurrentUser } from '../../../../lib/currentUser'

export interface UserState extends CurrentUser {
    isAdmin: boolean
}

const initialState: UserState = {
    isAdmin: false,
    id: '',
    firstName: '',
    lastName: '',
    password: '',
    passwordChange: null,
    mobile: '',
    email: '',
    userType: '',
    partnerId: 0,
    personalAccept: '',
    companyAccept: null,
    lastLogin: '',
    userName: '',
    fullName: '',
    hostName: null,
    claims: [],
    isPartner: false,
    userStatus: 'Valid',
    roles: [],
    isSuperAdmin: false,
    roleInCompany: null,
    selectedCompanyId: '',
    features: [],
}

export const chargePointsSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (_, action: PayloadAction<CurrentUser>) => {
            const isAdmin =
                action.payload?.isSuperAdmin ||
                hasClaimForCompany(action.payload, action.payload?.selectedCompanyId, Claims.Admin)
            return { ...action.payload, isAdmin }
        },
        reset: () => {},
    },
})

export const { setUser, reset } = chargePointsSlice.actions

export default chargePointsSlice.reducer
